import type { User } from '../../../utils/loginUtils'
import { getMessage } from '../../../utils/messageUtils'

import './UserConfig.scss'
import { useState } from 'react'
import Spinner from '../../Spinner/Spinner'
import UserPopupForm from './UserPopupForm'
import { updateUser, userChanged } from '../../../utils/usersUtils'

interface UserPopupContentProps {
  currentUser: User
  user: User
  isMobile: boolean
}

function UserConfig({ currentUser, user, isMobile }: UserPopupContentProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [chatId, setChatId] = useState(user.telegram_chat_id || '')
  const [alerts, setAlerts] = useState(user.alerts === 1 || false)

  const saveUser = async () => {
    const newUser: User = {
      id: null,
      username: currentUser.username,
      password: password.trim(),
      telegram_chat_id: chatId.trim(),
      alerts: alerts ? 1 : 0,
      admin: 0,
    }

    if (userChanged(user!, newUser)) {
      setIsLoading(true)
      await updateUser(currentUser.id!, newUser)
      setIsLoading(false)
    } else {
      return undefined
    }
  }
  return (
    <div className="user-config-tab">
      <h2>{getMessage('user_config_title')}</h2>
      <div
        className={`user-config-tab-form pop-up-form ${isMobile ? 'user-config-tab-form-mobile pop-up-form-mobile' : ''}`}
      >
        <UserPopupForm
          currentUser={currentUser}
          creatingNew={false}
          name={user.username}
          setName={() => {}}
          password={password}
          setPassword={setPassword}
          chatId={chatId}
          setChatId={setChatId}
          alerts={alerts}
          setAlerts={setAlerts}
          admin={false}
          setAdmin={() => {}}
          isMobile={isMobile}
        />
        <Spinner isOpen={isLoading} overlay={true} />
      </div>
      <button
        className={`user-config-save-button ${isMobile ? 'user-config-save-button-mobile' : ''}`}
        onClick={saveUser}
      >
        {getMessage('save_changes')}
      </button>
    </div>
  )
}

export default UserConfig
